import { useState, useEffect } from 'react';

import {
  Product,
  ReviewsData,
  ReviewsFilter
} from '@/fo/ui/review/catalog/base';

import { getReviews } from '../api/getReviews';

const INITIAL_PAGE = 1;

export function useReviews(product: Product, initialReviewsData: ReviewsData) {
  const [reviewsData, setReviewsData] = useState(initialReviewsData);
  const [reviewsPage, setReviewsPage] = useState(INITIAL_PAGE);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [reviewsFilters, setReviewsFilters] = useState<ReviewsFilter>({
    selectedRating: null,
    selectedTags: []
  });

  const fetchInitialReviews = async () => {
    const reviewsData = await getReviews(
      product.id,
      reviewsPage,
      reviewsFilters
    );
    setReviewsData(reviewsData.reviews);
    setShowLoadMore(reviewsData.pageInfo.totalPages > reviewsPage);
  };

  useEffect(() => {
    fetchInitialReviews();
  }, []);

  const handleFiltersChange = async (filters: ReviewsFilter) => {
    setReviewsPage(INITIAL_PAGE);
    setReviewsLoading(true);

    setReviewsFilters(filters);

    const reviewsData = await getReviews(product.id, INITIAL_PAGE, filters);

    setReviewsData(reviewsData.reviews);
    setShowLoadMore(reviewsData.pageInfo.totalPages > reviewsPage);
    setReviewsLoading(false);
  };

  const fetchMoreReviews = async () => {
    setReviewsLoading(true);

    const reviewsData = await getReviews(
      product.id,
      reviewsPage + 1,
      reviewsFilters
    );

    setReviewsData((prev) => {
      const allItems = [...prev.items, ...reviewsData.reviews.items];
      const uniqueMap = new Map(allItems.map((item) => [item.id, item]));
      const uniqueItems = Array.from(uniqueMap.values());
      return {
        ...reviewsData.reviews,
        items: uniqueItems
      };
    });

    setShowLoadMore(reviewsData.pageInfo.totalPages > reviewsPage + 1);

    setReviewsPage(reviewsPage + 1);
    setReviewsLoading(false);
  };

  return {
    reviewsData,
    reviewsLoading,
    fetchMoreReviews,
    handleFiltersChange,
    showLoadMore
  };
}
